import React, { useMemo, useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import apiUrl from "../../environment/Api";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import excelFile from "../../assets/course_demo.xlsx";
import Select from "react-select";
import ActionsDropdown from "../ActionsDropdown";
import styled from "styled-components";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  useSortBy,
  usePagination,
} from "react-table";
import { createPortal } from "react-dom";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

const TableContainer = styled.div`
  padding: 20px;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;

  tr:nth-child(odd) {
    background-color: #f2f2f2;
  }

  tr:nth-child(even) {
    background-color: #ffffff;
  }
`;

const Th = styled.th`
  padding: 10px;
  background-color: #fff;
  text-align: left;
  cursor: pointer;
  position: relative;
`;

const Td = styled.td`
  padding: 10px;
`;

function GlobalFilter({ globalFilter, setGlobalFilter }) {
  return (
    <div style={{ marginBottom: "10px" }}>
      <input
        value={globalFilter || ""}
        onChange={(e) => setGlobalFilter(e.target.value)}
        placeholder="Search all columns..."
        style={{
          padding: "5px",
          border: "1px solid #ddd",
          borderRadius: "4px",
          width: "100%",
        }}
      />
    </div>
  );
}

const DefaultColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}) => {
  const [isActive, setIsActive] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const options = useMemo(() => {
    const uniqueValues = Array.from(
      new Set(preFilteredRows.map((row) => row.values[id]))
    ).map((value) => ({ label: value, value }));
    return [{ label: "All", value: "" }, ...uniqueValues];
  }, [id, preFilteredRows]);

  const handleIconClick = () => {
    setIsActive(!isActive);
  };

  const handleMultiSelectChange = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFilter(values.length > 0 ? values : undefined);
  };

  return (
    <div style={{ alignItems: "center" }}>
      <div>
        <i
          className="fa-solid fa-ellipsis-vertical"
          onClick={handleIconClick}
          style={{
            cursor: "pointer",
            fontSize: "20px",
            color: "#AC0000",
          }}
        ></i>
      </div>
      <div>
        {isActive &&
          createPortal(
            <div
              style={{
                position: "fixed",
                zIndex: 9999,
                left: "50%",
                top: "50%",
                width: "30%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <div
                style={{
                  position: "relative",
                  background: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  backgroundColor: "#A70000",
                }}
              >
                <Select
                  options={options}
                  isMulti
                  value={options.filter((option) =>
                    filterValue?.includes(option.value)
                  )}
                  onChange={handleMultiSelectChange}
                  isClearable
                  isSearchable
                  placeholder={`Filter ${id}`}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                    }),
                  }}
                />
                <button
                  style={{
                    marginTop: "10px",
                    marginLeft: "150px",
                    padding: "5px 10px",
                    background: "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsActive(false)}
                >
                  Close
                </button>
              </div>
            </div>,
            document.body
          )}
      </div>
    </div>
  );
};

function Student() {
  const [responseData, setResponseData] = useState([]);
  const [responseDatas, setResponseDatas] = useState([]);
  const [responseDataed, setResponseDataed] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isUpdateshowModal, setUpdateShowModal] = useState(false);
  const [isUpdateshowModal1, setUpdateShowModal1] = useState(false);
  const [Updateshow, setUpdateShow] = useState(false);
  const [deleteShowModals, setDeleteShowModals] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [category, setcategory] = useState([]);
  const [role_id, setroleid] = useState("");
  const [previllages, setprevillages] = useState({});
  const [loading, setLoading] = useState(false);
  const [assignStaff, setAssignStaff] = useState(null);
  const [defaultBranchId, setDefaultBranchId] = useState(null);
  const navigate = useNavigate();

  const data = useMemo(() => {
    return responseData.map((item, index) => ({
      _id: item._id,
      branch_name: item.branch_id?.branch_name,
      branch_id: item.branch_id?._id,
      mobile_no: item.mobile_no,
      email: item.email,
      student_name: item.student_name,
      Prefered_course: item.Prefered_course,
      Source_type: item.Source_type,
      Enquiry_date: item.Enquiry_date,
      Enquiry_time: item.Enquiry_time,
      followups_status: item.followups_status,
      referal_candidate: item.referal_candidate,
      referal_candidate_name: item.referal_candidate_name,
      qualification: item.qualification,
      serialNo: index + 1,
    }));
  }, [responseData]);

  const columns = useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "serialNo",
        disableFilters: true,
      },
      {
        Header: "Branch",
        accessor: "branch_name",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Name",
        accessor: "student_name",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Course",
        accessor: "Prefered_course",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Source",
        accessor: "Source_type",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Date",
        accessor: (row) => {
          const date = new Date(row.Enquiry_date);
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        },
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Time",
        accessor: "Enquiry_time",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Status",
        accessor: "followups_status",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        width: 120,
        height: 10,
        Cell: ({ value }) => {
          const statusClass = getStatusLabelClass(value);
          return (
            <span
              className={`${statusClass}`}
              style={{
                display: "inline-block",
                width: "120px",
                height: "20px",
                lineHeight: "15px",
                textAlign: "center",
              }}
            >
              {value}
            </span>
          );
        },
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
    setPageSize,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 5 },
      defaultColumn: { Filter: DefaultColumnFilter },
      filterTypes: {
        multiSelectFilter: (rows, columnIds, filterValue) => {
          if (!filterValue || filterValue.length === 0) {
            return rows;
          }
          return rows.filter((row) => {
            const rowValue = row.values[columnIds[0]];
            const rowValueStr = String(rowValue);
            return filterValue.some((filterVal) =>
              rowValueStr.includes(String(filterVal))
            );
          });
        },
      },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const [selected_category, setselected_category] = useState("");
  const [UpdatedData, setUpdatedData] = useState({
    branch_id: "",
    student_name: "",
    mobile_no: "",
    email: "",
    other_location: "",
    category: "",
    Source_type: "",
    referal_candidate: "",
    referal_candidate_name: "",
    followups_date: "",
    followups_time: "",
    Enquiry_date: "",
    Enquiry_time: "",
    Prefered_course: "",
    assign_staff: "",
    qualification: "",
    purpose_enquiry: "",
    course_id: "",
    followups_status: "",
    followups_notes: "",
    interest: "",
    contact_type: "",
    status_time: "",
    _id: ""
  });

  const updateinfo = (_id) => {
    navigate(`/Leadhistroy/${_id}`);
  };

  const handleUpdatednew = (_id, data) => {
    setUpdateId(_id);
    console.log(" the data to updata", data);
    setUpdateShow(true);
    setUpdateData({
      branch_id: UpdatedData.branch_id,
      student_name: UpdatedData.student_name,
      mobile_no: UpdatedData.mobile_no,
      email: UpdatedData.email,
      other_location: UpdatedData.other_location,
      category: UpdatedData.category,
      Source_type: UpdatedData.Source_type,
      referal_candidate: UpdatedData.referal_candidate,
      referal_candidate_name: UpdatedData.referal_candidate_name,
      followups_date: updateData.followups_date,
      followups_time: updateData.followups_time,
      Enquiry_date: UpdatedData.Enquiry_date,
      Enquiry_time: UpdatedData.Enquiry_time,
      Perfered_course: UpdatedData.selectcourse,
      assign_staff: UpdatedData.assign_staff,
      qualification: UpdatedData.qualification,
    });
  };

  useEffect(() => {
    fetchData();
    getprevillages();
    fetchCategory();
    fetchSourceTypes();
    fetchPurposeTypes();
  }, []);

  // Set default branch to Erode on component mount
  useEffect(() => {
    const setDefaultErodeBranch = async () => {
      try {
        const response = await axios.get(apiUrl + "/Branch");
        const erodeBranch = response.data.find(branch => 
          branch.branch_name.toLowerCase().includes("erode")
        );
        
        if (erodeBranch) {
          setDefaultBranchId(erodeBranch._id);
          setAddData(prev => ({
            ...prev,
            branch_id: erodeBranch._id
          }));
          console.log("Default branch set to Erode:", erodeBranch.branch_name);
        }
      } catch (error) {
        console.error("Error setting default branch:", error);
      }
    };
    
    setDefaultErodeBranch();
  }, []);

  // Fetch category list
  const fetchCategory = async () => {
    try {
      const response = await axios.get(apiUrl + "/category_list");
      console.log("Category list fetched:", response.data);
      setcategory(response.data);
    } catch (error) {
      console.error("Error fetching category:", error.message);
    }
  };

  // Fetch source types
  const fetchSourceTypes = async () => {
    try {
      const response = await axios.get(apiUrl + "/source_type");
      console.log("Source types fetched:", response.data);
      const hasWebsite = response.data.some(item => 
        (item.source_type === "Website") || item === "Website"
      );
      if (!hasWebsite) {
        setResponsesource([...response.data, { source_type: "Website" }]);
      } else {
        setResponsesource(response.data);
      }
    } catch (error) {
      console.error("Error fetching source types:", error.message);
      setResponsesource([{ source_type: "Website" }, { source_type: "Reference" }, { source_type: "Other" }]);
    }
  };

  // Fetch purpose types
  const fetchPurposeTypes = async () => {
    try {
      const response = await axios.get(apiUrl + "/enquiry_purpose");
      console.log("Purpose types fetched:", response.data);
      setResponsepurpose(response.data);
    } catch (error) {
      console.error("Error fetching purpose types:", error.message);
    }
  };

  // FIXED: fetchDatas_2 function - removed hardcoded data
const fetchDatas_2 = async (selected_category_2) => {
  try {
    console.log("📞 Fetching courses for category:", `"${selected_category_2}"`);
    
    if (!selected_category_2) {
      setResponseDatas([]);
      return;
    }
    
    // Trim to remove spaces
    const trimmedCategory = selected_category_2.trim();
    
    const apiEndpoint = `${apiUrl}/category_course/${encodeURIComponent(trimmedCategory)}`;
    console.log("🌐 API Call:", apiEndpoint);
    
    const response = await axios.get(apiEndpoint);
    
    console.log("✅ API Response:", response.data);
    
    if (response.data && response.data.length > 0) {
      setResponseDatas(response.data);
      console.log(`✅ Loaded ${response.data.length} courses`);
    } else {
      console.warn(`⚠️ No courses found for "${trimmedCategory}"`);
      setResponseDatas([]);
      
      // Show user-friendly message
      toast.warning(`No courses available for "${trimmedCategory}". Please contact support.`);
    }
  } catch (error) {
    console.error("❌ Error fetching courses:", error);
    setResponseDatas([]);
    toast.error("Failed to load courses. Please try again.");
  }
};

 const handleUpdated = async (_id, data, qualification) => {
  if (previllages.edit || previllages.all) {
    try {
      setLoading(true);
      const filterUpdateData = await axios.get(apiUrl + `/leads/${_id}`);
      const leadData = Array.isArray(filterUpdateData.data) 
        ? filterUpdateData.data[0] 
        : filterUpdateData.data;

      if (!leadData) {
        toast.error("Lead data not found");
        setLoading(false);
        return;
      }

      await fetchDatas(); // load all courses first

      await new Promise(resolve => setTimeout(resolve, 500));

      const matchedCourse = responseDatas.find(
        (item) => item.course_name === leadData.Prefered_course
      );

      const categoryValue = matchedCourse?.category_list || leadData.category || "";

      // ✅ FIX: Only fetch category courses if it's a real category
      const invalidCategories = ["Website Enquiry", "Selected Course", "General", "General Enquiry", ""];
      
      if (categoryValue && !invalidCategories.includes(categoryValue)) {
        await fetchDatas_2(categoryValue);
        await new Promise(resolve => setTimeout(resolve, 300));
      }
      // else: keep all courses loaded from fetchDatas() above

      const updatedDataObject = {
        _id: leadData._id,
        branch_id: leadData.branch_id?._id || leadData.branch_id || "",
        student_name: leadData.student_name || "",
        mobile_no: leadData.mobile_no || "",
        email: leadData.email || "",
        other_location: leadData.other_location || "",
        category: invalidCategories.includes(categoryValue) ? "" : categoryValue, // ← reset to empty if invalid
        Source_type: leadData.Source_type || "Website",
        referal_candidate: leadData.referal_candidate || "",
        referal_candidate_name: leadData.referal_candidate_name || "",
        followups_date: leadData.followups_date || new Date().toISOString().split("T")[0],
        followups_time: leadData.followups_time || getCurrentTime(),
        Enquiry_date: leadData.Enquiry_date || "",
        Enquiry_time: leadData.Enquiry_time || "",
        Prefered_course: leadData.Prefered_course || "",
        assign_staff: leadData.assign_staff || "",
        qualification: leadData.qualification || "",
        purpose_enquiry: leadData.purpose_enquiry || "",
        course_id: matchedCourse?.course_id || leadData.course_id || "",
        followups_status: leadData.followups_status || "New",
        followups_notes: leadData.followups_notes || "",
        interest: leadData.interest || "",
        contact_type: leadData.contact_type || "",
        status_time: leadData.status_time || ""
      };

      setUpdatedData(updatedDataObject);
      setLoading(false);
      setUpdateShow(true);

    } catch (error) {
      console.error("❌ Error fetching updated data:", error);
      toast.error("Failed to load lead data");
      setLoading(false);
    }
  }
};
  const formatDatefitching = (isoDate) => {
    if (!isoDate) return "";
    const date = new Date(isoDate);
    return date.toISOString().split("T")[0];
  };

  useEffect(() => {
    const currentTime = new Date().toLocaleTimeString("en-US", {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
    });

    console.log("the time current", currentTime);
    setUpdatedData((prevData) => ({
      ...prevData,
      followups_time: currentTime,
    }));
    formatDateTime();
  }, []);

  const formatDate = (isoDate) => {
    if (!isoDate) return "";
    const date = new Date(isoDate);

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const formatDateTime = () => {
    const currentTime = new Date();
    const lastTime = new Date(currentTime);

    lastTime.setSeconds(lastTime.getSeconds());

    const hours = lastTime.getHours().toString().padStart(2, "0");
    const minutes = lastTime.getMinutes().toString().padStart(2, "0");
    const seconds = lastTime.getSeconds().toString().padStart(2, "0");

    return `${hours}:${minutes}:${seconds}`;
  };

  const [addData, setAddData] = useState({
    branch_id: "",
    selectcourse: "",
    student_name: "",
    father_name: "",
    timings: "",
    category: "",
    date: formatDatefitching(new Date()),
    Enquiry_time: formatDateTime(new Date()),
    dateofbirth: "",
    qualification: "",
    purpose_enquiry: "",
    mobile_no: "",
    email: "",
    notes: "",
    status: "",
    total_fees: "",
    paid: "",
    balance: "",
    student_type: "",
    Source_type: "",
    other_location: "",
    callback_date: "",
    converted_status: "",
    completed: "",
    referal_candidate: "",
    referal_candidate_name: "",
    course_id: "",
  });

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    setUpdatedData((prevData) => ({
      ...prevData,
      followups_date: today,
    }));
  }, []);

  const getCurrentTime = () => {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  useEffect(() => {
    setUpdatedData((prev) => ({
      ...prev,
      followups_time: getCurrentTime(),
    }));
    console.log("the time current1212", UpdatedData.followups_time);
  }, []);
  
  const [updateData, setUpdateData] = useState({
    student_name: "",
    other_location: "",
    date: formatDate(new Date()),
    followups_time: getCurrentTime(),
    mobile_no: "",
    category: "",
    status: "",
    callback_date: "",
    roll_no: "",
    photo_upload: "",
    id_proof: "",
  });
  
  const [idlocal, setlocalid] = useState([]);

  useEffect(() => {
    const fetchStaffData = async () => {
      try {
        await fetchData();
        const response = await axios.get(apiUrl + "/staff");

        const id_local = localStorage.getItem("username");
        const getid = response.data.filter((item) => item.empid === id_local);

        console.log(getid, "gopi1");
        console.log(getid[0]?._id, "gopi");
        setlocalid({ id: getid[0]?._id, empid: id_local });
      } catch (error) {
        console.error("Error fetching staff data:", error);
      }
    };

    fetchStaffData();
  }, []);

  useEffect(() => {
    const fetchStaffData = async () => {
      try {
        const response = await axios.get(apiUrl + "/staff");
        const id_local = localStorage.getItem("username");

        if (!id_local) {
          console.error("No empid found in localStorage.");
          return;
        }

        const getid = response.data.filter((item) => item.empid === id_local);

        if (getid.length > 0) {
          const staffData = getid[0];
          console.log(staffData, "Found Staff Data");
          setlocalid({ id: staffData._id, empid: id_local });
        } else {
          console.log("No staff data found for empid", id_local);
        }
      } catch (error) {
        console.error("Error fetching staff data:", error);
      }
    };

    fetchStaffData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(apiUrl + "/leadsnew", {
        params: { data: localStorage.getItem("branch_id") },
      });

      console.log("Response from serverrrr leadsnew:", response.data.reverse());
      if (response && response.data) {
        const data = response.data;
        console.log("Error fetching data:data", data);
        const filteredData = data.filter((item) => item.status !== "Converted");
        setResponseData(filteredData);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  useEffect(() => {
    fetchDatas();
    gettoken();
    fetch();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fetch = async () => {
    try {
      const response = await axios.get(apiUrl + "/category_list");
      console.log("Response from server:", response.data);
      console.log("Response from category list :", category);
      setcategory(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const fetchDatas = async () => {
    try {
      const response = await axios.get(apiUrl + "/course");
      console.log("Response from server (all courses):", response.data);
      setResponseDatas(response.data);
      setAllCourses(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const [allCourses, setAllCourses] = useState([]);

  const gettoken = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.post(apiUrl + "/get_detail", {
        token: token,
      });
      console.log("token detail from server:", response.data);

      console.log("The role id is : ", response.data.detail.rolename);
      setroleid(response.data.detail.rolename);
      console.log("the role_id is : ", role_id);

      localStorage.setItem("role_id", response.data.detail.rolename);

      const id = response.data.detail.rolename;

      if (id) {
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const handlesubmit = async (e) => {
    e.preventDefault();
    if (!validateFields()) {
      return;
    }
    try {
      setLoading(true);
      const formData = {
        branch_id: addData.branch_id,
        student_name: addData.student_name,
        mobile_no: addData.mobile_no,
        category: addData.category,
        email: addData.email,
        other_location: addData.other_location,
        Source_type: addData.Source_type,
        referal_candidate: addData.referal_candidate,
        referal_candidate_name: addData.referal_candidate_name,
        Enquiry_date: addData.date,
        Enquiry_time: formatDateTime(addData.Enquiry_time),
        Prefered_course: addData.selectcourse,
        followups_status: "New",
        course_id: addData.course_id,
        qualification: addData.qualification,
        purpose_enquiry: addData.purpose_enquiry,
      };

      console.log("formData,OO:", formData);
      const response = await axios.post(apiUrl + "/leads", formData);

      console.log("the histroy begins", response);

      setShowModal(false);

      toast.success("added successfully!");
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      setAddData({
        branch_id: defaultBranchId || "",
        student_name: "",
        mobile_no: "",
        category: "",
        email: "",
        Source_type: "",
        qualification: "",
        purpose_enquiry: "",
        other_location: "",
        Enquiry_time: "",
        referal_candidate: "",
        referal_candidate_name: "",
        date: formatDatefitching(new Date()),
        status: "",
        student_type: "",
        selectcourse: "",
      });
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  const [updateid, setUpdateId] = useState("");

  const [firstTime, setFirstTime] = useState(null);
  const [lasttimess, setLastTime] = useState(null);
  const [timeDifference, setTimeDifference] = useState(null);

  const updateshow = async (_id, data) => {
    const currentTimes = new Date().toLocaleTimeString();

    console.log(`Current Time: ${currentTimes}`);
    setFirstTime(currentTimes);

    setUpdateId(data._id);
    console.log("this vv", data);
    const filterUpdateData = await axios.get(apiUrl + `/leads/${_id}`);

    console.log(
      "the filter daata is find here",
      filterUpdateData.data?.[0],
      "filterUpdateData___999"
    );
    setUpdatedData(data);
    console.log(" the data to updata", updateData);
    console.log("data.assign_staff:1212", data.Prefered_course);
    console.log("localStorage.assignId:", localStorage.getItem("assignId"));

    const courses = responseDatas.find(
      (item) => item.course_name === data.Prefered_course
    );
    console.log("the courserr12", courses);
    if (courses) {
      const coursedata = courses.category_list;
      console.log("the courserr12", courses);
      console.log("the course category_list", coursedata);

      setUpdatedData((prevData) => ({
        ...prevData,
        category: coursedata,
      }));
    } else {
      console.log("No matching course found for Prefered_course.");
    }

    console.log("filterUpdateData___category ", UpdatedData.category);

    setUpdateShowModal(true);
    setUpdateData({
      branch_id: data.branch_id,
      student_name: data.student_name,
      mobile_no: data.mobile_no,
      category: data.category,
      email: data.email,
      other_location: data.other_location,
      Source_type: data.Source_type,
      qualification: data.qualification,
      purpose_enquiry: data.purpose_enquiry,
      referal_candidate: data.referal_candidate,
      followups_date: data.date,
      followups_time: data.followups_time,
      referal_candidate_name: data.referal_candidate_name,
      Enquiry_date: data.date,
      Enquiry_time: data.Enquiry_time,
      assign_staff: data.assign_staff || localStorage.getItem("assignId"),
      Perfered_course: data.selectcourse,
      followups_status: "new",
      course_id: "",
    });
  };

  const handleupdatesubmit = async (id) => {
    try {
      console.log(id, "the Id is");
      const updateDatas = {
        branch_id: UpdatedData.branch_id,
        student_name: UpdatedData.student_name,
        mobile_no: UpdatedData.mobile_no,
        category: UpdatedData.category,
        email: UpdatedData.email,
        other_location: UpdatedData.other_location,
        Source_type: UpdatedData.Source_type,
        purpose_enquiry: UpdatedData.purpose_enquiry,
        qualification: UpdatedData.qualification,
        referal_candidate: UpdatedData.referal_candidate || "",
        referal_candidate_name: UpdatedData.referal_candidate_name || "",
        Enquiry_date: UpdatedData.Enquiry_date,
        Enquiry_time: UpdatedData.Enquiry_time,
        Prefered_course: UpdatedData.Prefered_course,
        course_id: UpdatedData.course_id,
        followups_date: UpdatedData.status_date,
        status_time: UpdatedData.status_time,
        followups_status: UpdatedData.followups_status,
        followups_notes: UpdatedData.followups_notes,
        interest: UpdatedData.interest,
        assign_staff: updateData.assign_staff || null,
      };

      try {
        setLoading(true);
        console.log(
          "The console update  data as is :12 ",
          updateDatas,
          updateid
        );
        const response = await axios.put(apiUrl + `/leads/${id}`, updateDatas);
        console.log("the response  the  updayteeee dataaaa : ", response);

        if (response.status == 200) {
          fetchData();
          toast.success("update sucessfully!");
          setUpdateShow(false);
        } else {
          toast.error("failed to convert !");
        }
      } catch (error) {
        toast.error("error in convert !");
        console.log("Error fetching data:", error.message);
      }
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
  
  const [detailsData, setDetailsData] = useState({
    assign_staff: "",
    contact_type: "",
    followups_date: "",
    followups_time: "",
  });

  const handleupdatesubmitdetails = async (id) => {
    try {
      const lasttimess = new Date().toLocaleTimeString("en-US", {
        hour12: true,
      });
      console.log(`End Time: ${lasttimess}`);
      setLastTime(lasttimess);
      console.log(`Start Time: ${firstTime}`);
      const firstTimeDate = new Date(
        `1970-01-01T${convertTo24Hour(firstTime)}Z`
      );
      const lastTimeDate = new Date(
        `1970-01-01T${convertTo24Hour(lasttimess)}Z`
      );

      const timeDifferenceInMillis = lastTimeDate - firstTimeDate;
      const timeDifferenceInSeconds = Math.max(
        timeDifferenceInMillis / 1000,
        0
      );

      const formatDuration = (seconds) => {
        const hrs = Math.floor(seconds / 3600)
          .toString()
          .padStart(2, "0");
        const mins = Math.floor((seconds % 3600) / 60)
          .toString()
          .padStart(2, "0");
        const secs = (seconds % 60).toString().padStart(2, "0");
        return `${hrs}:${mins}:${secs}`;
      };

      const durationFormatted = formatDuration(timeDifferenceInSeconds);
      console.log(`Time difference: ${durationFormatted}`);

      setTimeDifference(durationFormatted);

      function convertTo24Hour(time) {
        const [timePart, modifier] = time.split(" ");
        let [hours, minutes, seconds] = timePart.split(":");

        if (modifier === "PM" && hours !== "12") hours = parseInt(hours) + 12;
        if (modifier === "AM" && hours === "12") hours = "00";

        return `${hours}:${minutes}:${seconds}`;
      }

      console.log("schudule updateeeee ", timeDifference);
      let followupsdate = new Date().toISOString().split("T")[0];

      if (idlocal) {
        const assign_staff = idlocal.id;
        setAssignStaff(assign_staff);
      }

      const updateDatasDetails = {
        branch_id: UpdatedData.branch_id,
        student_name: UpdatedData.student_name,
        mobile_no: UpdatedData.mobile_no,
        category: UpdatedData.category,
        email: UpdatedData.email,
        other_location: UpdatedData.other_location,
        Source_type: UpdatedData.Source_type,
        purpose_enquiry: UpdatedData.purpose_enquiry,
        qualification: UpdatedData.qualification,
        referal_candidate: UpdatedData.referal_candidate || "",
        referal_candidate_name: UpdatedData.referal_candidate_name || "",
        Enquiry_date: UpdatedData.Enquiry_date,
        Enquiry_time: UpdatedData.Enquiry_time,

        Prefered_course: UpdatedData.Prefered_course,
        assign_staff: UpdatedData.assign_staff || idlocal?.id,
        contact_type: UpdatedData.contact_type,
        followups_date: followupsdate || UpdatedData.followups_date,
        followups_time: UpdatedData.followups_time,

        status_time: UpdatedData.status_time,
        followups_status:
          UpdatedData.followups_status === "New"
            ? "Scheduled"
            : UpdatedData.followups_status,
        followups_notes: UpdatedData.followups_notes,
        interest: UpdatedData.interest,

        duration_time: durationFormatted,
        start_time: firstTime,
        end_time: lasttimess,
      };

      try {
        setLoading(true);
        console.log("The console update1  data", updateDatasDetails);
        console.log("The console update2  data as is : ", updateid);
        const response = await axios.put(
          apiUrl + `/leads/${id}`,
          updateDatasDetails
        );
        if (response.status === 200) {
          fetchData();
          window.location.reload();
        }
        console.log("the response : ", response);

        const student_Id = response.data._id;
        console.log("the histroy  update post", student_Id);
        const formDataaa = {
          student_Id: student_Id,
          Source_type: "",
          Enquiry_date: "",

          contact_type: UpdatedData.contact_type,
          assign_staff: UpdatedData.assign_staff || idlocal?.id,
          notes: "following notes  ",
          status: UpdatedData.followups_status,
          duration_time: timeDifferenceInSeconds,
          start_time: firstTime,
          end_time: lasttimess,
          Enquiry_time: UpdatedData.Enquiry_time,
          Enquiry_time: formatDateTime(new Date()),
        };

        if (response.status == 200) {
          const response12 = await axios.post(
            apiUrl + "/leadhistroy",
            formDataaa
          );
          console.log("the histroy begins", response12);
        }

        if (response.status == 200) {
          fetchData();
          toast.success("converted sucessfully!");
          setUpdateShowModal(false);
        } else {
          toast.error("failed to convert !");
        }
      } catch (error) {
        toast.error("error in convert !");
        console.log("Error fetching data:", error.message);
      }
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  useEffect(() => {
    fetchDatased();
    fetchDataseded();
  }, []);
  
  const [branch, setbranch] = useState([]);
  const [studentId, setSutudentId] = useState([]);
  const [stafftId, setStaffId] = useState([]);
  const [responsepurpose, setResponsepurpose] = useState([]);
  const [responsesource, setResponsesource] = useState([]);
  
  const fetchDatased = async () => {
    try {
      const response = await axios.get(apiUrl + "/Branch");
      const responsestudent = await axios.get(apiUrl + "/student");
      const responsestaff = await axios.get(apiUrl + "/staff");
      const responsepurposes = await axios.get(apiUrl + "/enquiry_purpose");
      const responsesources = await axios.get(apiUrl + "/source_type");

      console.log("Response from server branch:", response.data);
      console.log("Response from server student:", responsestudent.data);
      console.log("Response from server staff user:", responsestaff.data);
      console.log("Response from source types:", responsesources.data);
      console.log("Response from purpose types:", responsepurposes.data);
      
      const erodeBranch = response.data.find(branch => 
        branch.branch_name.toLowerCase().includes("erode")
      );
      
      if (erodeBranch && !addData.branch_id && defaultBranchId) {
        setAddData(prev => ({
          ...prev,
          branch_id: erodeBranch._id
        }));
      }
      
      const hasWebsite = responsesources.data.some(item => 
        (item.source_type === "Website") || item === "Website"
      );
      if (!hasWebsite) {
        setResponsesource([...responsesources.data, { source_type: "Website" }]);
      } else {
        setResponsesource(responsesources.data);
      }
      setResponsepurpose(responsepurposes.data);
      setbranch(response.data);
      setSutudentId(responsestudent.data);
      setStaffId(responsestaff.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };
  
  const [referaltype, setreferaltype] = useState("");

  const handlereferal = (e) => {
    console.log(e.target.value);
    setAddData({ ...addData, referal_candidate: e.target.value });
    setreferaltype(e.target.value);
  };
  
  const [seduledStatus, setSeduledStatus] = useState("");

  function handleschuduleStatus(e) {
    console.log(e.target.value);
    setAddData({ ...addData, referal_candidate_name: e.target.value });
    setSeduledStatus(e.target.value);
  }
  
  const handleDelete = async (id) => {
    try {
      setLoading(true);
      const response = await axios.delete(apiUrl + `/leads/${getdeleteid}`);
      console.log("delete data ", response);
      toast.error("Delete successfully!");
      setDeleteShowModals(false);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  const handleCloseModal = () => {
    setDeleteShowModals(false);
  };

  const [getdeleteid, setdeleteid] = useState("");
  const [getdeletename, setdeletename] = useState("");
  
  const handleOpenModal = (_id, student_name) => {
    if (previllages.all || previllages.delete) {
      console.log(" the id", _id);
      console.log(" the studentname", student_name);
      setdeleteid(_id);
      setdeletename(student_name);
      setDeleteShowModals(true);
    } else {
      toast.error("You don't have the permission");
    }
  };

  const handleStatusChange = (e) => {
    const selectedStatus = e.target.value;
    setAddData({ ...addData, status: selectedStatus });

    if (selectedStatus === "Callback") {
      setShowCallbackDate(true);
    } else {
      setShowCallbackDate(false);
      setAddData((prevData) => ({
        ...prevData,
        callbackdate: "",
      }));
    }
  };

  const handleStatusChangeupdate = (e) => {
    const selectedStatus = e.target.value;
    setUpdateData({ ...updateData, status: selectedStatus });

    if (selectedStatus === "Callback") {
      setShowCallbackDate(true);
    } else {
      setShowCallbackDate(false);
      setUpdateData((prevData) => ({
        ...prevData,
        callbackdate: "",
      }));
    }
  };

  const [showCallbackDate, setShowCallbackDate] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = responseData.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const filtered = rows.filter((item) =>
    Object.values(item).some(
      (value) =>
        (typeof value === "string" &&
          value.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (typeof value === "number" && value.toString().includes(searchQuery))
    )
  );

  const createPagination = () => {
    let liTag = [];
    let totalPages = pageCount;
    let currentPage = state.pageIndex;
    let active;

    liTag.push(
      <li
        className={`page-item ${!canPreviousPage ? "disabled" : ""}`}
        key="prev"
      >
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage - 1)}
          disabled={!canPreviousPage}
        >
          <FaAngleLeft /> Prev
        </button>
      </li>
    );

    if (totalPages > 1) {
      liTag.push(
        <li
          className={`page-item ${currentPage === 0 ? "active" : ""}`}
          key={0}
        >
          <button className="page-link" onClick={() => gotoPage(0)}>
            1
          </button>
        </li>
      );
    }

    if (totalPages > 2) {
      liTag.push(
        <li
          className={`page-item ${currentPage === 1 ? "active" : ""}`}
          key={1}
        >
          <button className="page-link" onClick={() => gotoPage(1)}>
            2
          </button>
        </li>
      );
    }

    if (currentPage > 3) {
      liTag.push(
        <li className="page-item disabled" key="dot-prev">
          <span className="page-link">...</span>
        </li>
      );
    }

    for (
      let i = Math.max(2, currentPage - 1);
      i <= Math.min(totalPages - 3, currentPage + 1);
      i++
    ) {
      active = currentPage === i ? "active" : "";
      liTag.push(
        <li className={`page-item ${active}`} key={i}>
          <button className="page-link" onClick={() => gotoPage(i)}>
            {i + 1}
          </button>
        </li>
      );
    }

    if (currentPage < totalPages - 4) {
      liTag.push(
        <li className="page-item disabled" key="dot-next">
          <span className="page-link">...</span>
        </li>
      );
    }

    if (totalPages > 2) {
      liTag.push(
        <li
          className={`page-item ${currentPage === totalPages - 2 ? "active" : ""
            }`}
          key={totalPages - 2}
        >
          <button
            className="page-link"
            onClick={() => gotoPage(totalPages - 2)}
          >
            {totalPages - 1}
          </button>
        </li>
      );
    }

    if (totalPages > 1) {
      liTag.push(
        <li
          className={`page-item ${currentPage === totalPages - 1 ? "active" : ""
            }`}
          key={totalPages - 1}
        >
          <button
            className="page-link"
            onClick={() => gotoPage(totalPages - 1)}
          >
            {totalPages}
          </button>
        </li>
      );
    }

    liTag.push(
      <li className={`page-item ${!canNextPage ? "disabled" : ""}`} key="next">
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage + 1)}
          disabled={!canNextPage}
        >
          Next <FaAngleRight />
        </button>
      </li>
    );

    return liTag;
  };

  const [newupdatedata, setnewupdatedata] = useState([]);

  const handleupdatesubmit2 = async (e) => {
    e.preventDefault();
    try {
      const formData = {
        branch_id: newupdatedata.branch_id,
        student_name: newupdatedata.student_name,
        mobile_no: newupdatedata.mobile_no,
        email: newupdatedata.email,
        Perfered_course: newupdatedata.selectcourse,
        Source_type: newupdatedata.Source_type,
        contact_type: newupdatedata.contact_type,
        assign_staff: newupdatedata.assign_staff,
        referal_candidate: newupdatedata.referal_candidate,
        referal_candidate_name: newupdatedata.referal_candidate_name,
        Enquiry_date: newupdatedata.date,
      };
      console.log("the update submit data", formData);
      const response = await axios.put(apiUrl + `/leads/${updateid}`, formData);
      console.log("response for update", response);
      setUpdateShowModal(false);
      toast.success("Update successfully!");
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };
  
  function handleChangeSatus(e) {
    const course = responseDatas.filter(
      (item, index) => item.course_id == e.target.value
    );
    console.log(course, "course---");
    setAddData({
      ...addData,
      course_id: e.target.value,
      selectcourse: course[0]?.course_name || "Course Not Found",
    });
  }
  
  function handleCOureseUpdate(e) {
    const selectedCourseId = e.target.value;
    const course = responseDatas.find(
      (item) => item.course_id === selectedCourseId
    );
    
    console.log("Selected course:", course);
    
    setUpdatedData({
      ...UpdatedData,
      course_id: selectedCourseId,
      Prefered_course: course?.course_name || "Not Found"
    });
  }

  // Handle category change in edit modal
  const handleEditCategoryChange = async (e) => {
    const selectedCategory = e.target.value;
    console.log("Selected category value:", `"${selectedCategory}"`);
    
    setUpdatedData({
      ...UpdatedData,
      category: selectedCategory,
      Prefered_course: "",
      course_id: ""
    });
    
    if (selectedCategory) {
      await fetchDatas_2(selectedCategory);
    } else {
      await fetchDatas();
    }
  };

  function interstedHandel(e) {
    console.log(e.target.value);

    setUpdatedData((prevData) => ({
      ...prevData,
      interest: e.target.value,
    }));
  }

  const getStatusLabelClass = (status) => {
    switch (status) {
      case "New":
        return "bg-info1 text-white1";
      default:
        return "";
    }
  };

  const [selectedCourse, setSelectedCourse] = useState(
    UpdatedData.Prefered_course || ""
  );

  const handleCourseChange = (event) => {
    setSelectedCourse(event.target.value);
    setUpdatedData({ ...UpdatedData, Prefered_course: event.target.value });
  };

  function classNameassstaff(e) {
    console.log("the assign staff value ", localStorage.getItem("assignId"));
    setUpdatedData({
      ...UpdatedData,
      assign_staff: e.target.value,
    });
  }

  // FIXED: handleAdditionalChange function
const handleAdditionalChange = async (e) => {
  const selectcategory = e.target.value;
  console.log("Category selected:", `"${selectcategory}"`);
  console.log("Category length:", selectcategory.length);
  
  setselected_category(e.target.value);
  
  setAddData(prev => ({
    ...prev,
    category: selectcategory,
    selectcourse: "",
    course_id: ""
  }));
  
  if (selectcategory) {
    console.log("Fetching courses for category:", selectcategory);
    await fetchDatas_2(selectcategory);
  } else {
    setResponseDatas([]);
  }
};

  const [errors, setErrors] = useState({});

  const validateFields = () => {
    let tempErrors = {};
    let isValid = true;

    if (!addData.branch_id) {
      tempErrors.branch_id = "Branch is required.";
      isValid = false;
    }

    if (!addData.student_name) {
      tempErrors.student_name = "Name is required.";
      isValid = false;
    }

    if (!addData.mobile_no) {
      tempErrors.mobile_no = "Mobile is required.";
      isValid = false;
    }

    if (!/^\d{10}$/.test(addData.mobile_no)) {
      tempErrors.mobile_no = "Mobile number must be 10 digits.";
      isValid = false;
    }

    if (!addData.email) {
      tempErrors.email = "Email is required.";
      isValid = false;
    }
    if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(addData.email)
    ) {
      tempErrors.email = "Please enter a valid email address.";
      isValid = false;
    }

    if (!addData.category) {
      tempErrors.category = "Select category is required.";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  const handleSelectChange = (e) => {
    setUpdatedData({
      ...UpdatedData,
      purpose_enquiry: e.target.value,
    });
  };

  const handleSelectChangesource = (e) => {
    setUpdatedData({
      ...UpdatedData,
      Source_type: e.target.value,
    });
  };

  const username = localStorage.getItem("username");

  const getprevillages = () => {
    const username = JSON.parse(localStorage.getItem("user_previllages"));
    console.log("tyhe username get by local stroage : ", username.modules);

    const total_previlages = username.modules;

    const new_enquiry = total_previlages.find(
      (item) => item.name == "New Enquiry"
    );

    console.log("the new_enquiry is : ", new_enquiry.actions);

    setprevillages(new_enquiry.actions);
  };

  const [filteredItems, setfilterdata] = useState([]);

  const fetchDataseded = async () => {
    try {
      const response = await axios.get(apiUrl + "/staff");
      console.log("Response from server:", response.data);
      setfilterdata(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const [rolename, setrolename] = useState([]);
  
  useEffect(() => {
    const branchName = localStorage.getItem("branch_name");
    setrolename(branchName);
  }, []);

  useEffect(() => {
    const currentTime = new Date().toLocaleTimeString("en-US", {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
    });

    setUpdatedData((prevData) => ({
      ...prevData,
      followups_time: currentTime,
    }));
  }, []);

  const handleClick = (_id) => {
    navigate(`/fileupload`);
  };

  useEffect(() => {
    const branchName = localStorage.getItem("branch_name");
    setrolename(branchName);
  }, []);

  const handleSelectChangedd = (e) => {
    setUpdatedData({
      ...UpdatedData,
      assign_staff: e.target.value,
    });
  };

  return (
    <>
      {loading === true ? (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/output-onlinegiftools.gif")}
            />{" "}
          </div>
        </div>
      ) : (
        <div className="d-none"></div>
      )}
      <div className="top">
        <div className="" style={{ marginTop: "-80px" }}>
          <div className="row mb-2">
            <div className="col-lg-9">
              <Link to="/dashboard" className="text-secondary dashBoard_text">
                <b>Dashboard / </b>
              </Link>
              <Link to="#" className="text-secondary dashBoard_text">
                <b>Leads / </b>
              </Link>
              <Link to="" className="text-danger dashBoard_text">
                <b>New Enquiry</b>
              </Link>
            </div>
            {rolename === "Branches" && (
              <div className="col-lg-3 d-flex justify-content-end">
                  <button className="btn btn-secondary" onClick={handleClick}>
                    File Upload
                 </button>
              </div>
            )}
          </div>
        </div>

        <div className="mb-1 mt-3">
          <div className="row">
            <div className="col-lg-7 col-md-4 col-sm-1 d-flex">
              <h5 className="mt-1">New Enquiry</h5>
              <div className="mx-3">
                {previllages.add && (
                  <button
                    className="btn btn-success add mx-3"
                    onClick={() => setShowModal(true)}
                  >
                    Add
                  </button>
                )}
              </div>
            </div>
            <div className="col-lg-5 col-md-4 col-sm-4 d-flex justify-content-end">
              <div className="w-full flex-1 me-5">
                <form>
                  <div className="relative">
                    <input
                      className="form-control w-full bg-white appearance-none pl-8 dark:bg-gray-950"
                      placeholder="Search ..."
                      type="search"
                      value={state.globalFilter || ""}
                      onChange={(e) => setGlobalFilter(e.target.value)}
                    />
                  </div>
                </form>
              </div>
              <div className="d-flex me-2">
                <label className="form-label text-dark mt-1">Show : </label>
                <div>
                  <select
                    className="form-control w-100 mx-2"
                    value={state.pageSize}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "All") {
                        setPageSize(data.length);
                      } else {
                        setPageSize(Number(value));
                      }
                    }}
                  >
                    <option value="All">All</option>
                    {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    <div className="d-flex">
                      <div className="mx-2">{column.render("Header")}</div>
                      <div>
                        {column.canFilter ? column.render("Filter") : null}
                      </div>
                      <div className="mx-1">
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </div>
                    </div>
                  </Th>
                ))}
                <Th className="text-center">Action</Th>
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <Td {...cell.getCellProps()}>{cell.render("Cell")}</Td>
                  ))}
                  <Td className="text-center">
                    <ActionsDropdown
                      row={row.original}
                      permissions={{
                        edit: previllages.edit,
                        delete: previllages.delete,
                      }}
                      onEdit={(id, row) =>
                        handleUpdated(id, row)
                      }
                      onDelete={(id, row) =>
                        handleOpenModal(id, row.student_name)
                      }
                      onAssign={(id, row) =>
                        updateshow(id, row)
                      }
                      onInfo={(id) => {
                        setLoading(true);
                        setTimeout(() => {
                          updateinfo(id);
                          setLoading(false);
                        }, 1000);
                      }}
                    />
                  </Td>
                </tr>
              );
            })}
          </tbody>
        </Table>

        <div className="insermodal">
          <Modal
            className="addmodals"
            show={showModal}
            onHide={() => setShowModal(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title id="modeti">New Enquiry</Modal.Title>
            </Modal.Header>
            <form>
              <Modal.Body>
                <div className="row">
                  <div className="col-lg-12 ">
                    <div className=" p-2 pb-0">
                      <div className="form-group">
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="floating-label mt-1">
                              <label className="form-label">
                                <b></b>
                              </label>
                              <select
                                className="form-select"
                                placeholder=""
                                value={addData.branch_id || defaultBranchId || ""}
                                onChange={(e) =>
                                  setAddData({
                                    ...addData,
                                    branch_id: e.target.value,
                                  })
                                }
                                required
                              >
                                <option value="">Select Branch </option>
                                {branch.map((item, index) => (
                                  <option key={index} value={item._id}>
                                    {item.branch_name}
                                  </option>
                                ))}
                              </select>
                              <label
                                className={addData.branch_id ? "filled" : ""}
                              >
                                Select Branch
                              </label>
                              {errors.branch_id && (
                                <div className="error-text">
                                  {errors.branch_id}
                                </div>
                              )}
                            </div>

                            <div className="col-lg-12">
                              <div className="floating-label">
                                <input
                                  className="form-control"
                                  type="text"
                                  placeholder=""
                                  value={addData.student_name}
                                  onChange={(e) =>
                                    setAddData({
                                      ...addData,
                                      student_name: e.target.value,
                                    })
                                  }
                                  required
                                />
                                <label
                                  className={
                                    addData.student_name ? "filled" : ""
                                  }
                                >
                                  Student Name
                                </label>
                                {errors.student_name && (
                                  <div className="error-text">
                                    {errors.student_name}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="col-lg-12">
                              <div className="floating-label">
                                <input
                                  className="form-control"
                                  type="text"
                                  inputMode="numeric"
                                  maxLength={10}
                                  placeholder=""
                                  value={addData.mobile_no}
                                  onChange={(e) =>
                                    setAddData({
                                      ...addData,
                                      mobile_no: e.target.value,
                                    })
                                  }
                                  required
                                />
                                <label
                                  className={addData.mobile_no ? "filled" : ""}
                                >
                                  Mobile No
                                </label>
                                {errors.mobile_no && (
                                  <div className="error-text">
                                    {errors.mobile_no}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="col-lg-12">
                              <div className="floating-label">
                                <input
                                  className="form-control"
                                  type="email"
                                  placeholder=""
                                  value={addData.email}
                                  onChange={(e) =>
                                    setAddData({
                                      ...addData,
                                      email: e.target.value,
                                    })
                                  }
                                  required
                                />
                                <label
                                  className={addData.email ? "filled" : ""}
                                >
                                  Email
                                </label>
                                {errors.email && (
                                  <div className="error-text">
                                    {errors.email}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="col-lg-12 mt-4">
                              <div className="floating-label mt-1">
                                <label className="form-label">
                                  <b></b>
                                </label>
                                <select
                                  className="form-select"
                                  placeholder=""
                                  value={addData.Source_type}
                                  onChange={(e) =>
                                    setAddData({
                                      ...addData,
                                      Source_type: e.target.value,
                                    })
                                  }
                                  required
                                >
                                  <option value="">Select Source Type </option>
                                  {responsesource && responsesource.length > 0 ? (
                                    responsesource.map((item, index) => (
                                      <option
                                        key={index}
                                        value={item.source_type || item}
                                      >
                                        {item.source_type || item}
                                      </option>
                                    ))
                                  ) : (
                                    <option disabled>Loading source types...</option>
                                  )}
                                </select>

                                <label
                                  className={
                                    addData.Source_type ? "filled" : ""
                                  }
                                >
                                  Select Source Type
                                </label>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-6 mt-1">
                            <div className="floating-label">
                              <label className="form-label">
                                <b></b>
                              </label>
                              <select
                                className="form-select"
                                value={addData.category}
                                onChange={(e) => {
                                  const selectedCategory = e.target.value;
                                  setAddData({
                                    ...addData,
                                    category: selectedCategory,
                                    course_id: "",
                                    selectcourse: "",
                                  });
                                  handleAdditionalChange(e);
                                }}
                                required
                              >
                                <option value="">Select Category</option>
                                {category && category.length > 0 ? (
                                  category.map((item, index) => (
                                    <option
                                      key={index}
                                      value={item.category_name}
                                    >
                                      {item.category_name}
                                    </option>
                                  ))
                                ) : (
                                  <option disabled>Loading categories...</option>
                                )}
                              </select>
                              <label
                                className={addData.category ? "filled" : ""}
                              >
                                Select Course Category
                              </label>
                              {errors.category && (
                                <div className="error-text">
                                  {errors.category}
                                </div>
                              )}
                            </div>

                            {/* FIXED: Course dropdown - shows courses filtered by selected category */}
                            {addData.category && (
                              <div className="col-lg-12 mt-4">
                                <div className="floating-label">
                                  <select
                                    className="form-select"
                                    value={addData.course_id}
                                    onChange={(e) => {
                                      const selectedCourseId = e.target.value;
                                      const selectedCourse = responseDatas.find(
                                        item => item.course_id === selectedCourseId
                                      );
                                      setAddData({
                                        ...addData,
                                        course_id: selectedCourseId,
                                        selectcourse: selectedCourse?.course_name || ""
                                      });
                                    }}
                                    required
                                  >
                                    <option value="">Select Preferred Course</option>
                                    {responseDatas && responseDatas.length > 0 ? (
                                      responseDatas.map((item, index) => (
                                        <option key={index} value={item.course_id}>
                                          {item.course_id} - {item.course_name}
                                        </option>
                                      ))
                                    ) : (
                                      <option disabled>No courses available for {addData.category}</option>
                                    )}
                                  </select>
                                  <label
                                    className={
                                      addData.course_id ? "filled" : ""
                                    }
                                  >
                                    Select Preferred Course
                                  </label>
                                </div>
                              </div>
                            )}

                            <div className="col-lg-12 mt-4">
                              <div className="floating-label">
                                <input
                                  className="form-control"
                                  type="date"
                                  placeholder=""
                                  value={addData.date}
                                  onChange={(e) =>
                                    setAddData({
                                      ...addData,
                                      date: e.target.value,
                                    })
                                  }
                                  required
                                />
                                <label className={addData.date ? "filled" : ""}>
                                  Enquiry Date
                                </label>
                              </div>
                            </div>

                            <div className="col-lg-12 mt-4">
                              <div className="floating-label">
                                <input
                                  className="form-control"
                                  type="text"
                                  placeholder=""
                                  value={addData.qualification}
                                  onChange={(e) =>
                                    setAddData({
                                      ...addData,
                                      qualification: e.target.value,
                                    })
                                  }
                                  required
                                />
                                <label
                                  className={
                                    addData.qualification ? "filled" : ""
                                  }
                                >
                                  Qualification
                                </label>
                              </div>
                            </div>

                            <div className="floating-label mt-1">
                              <label className="form-label">
                                <b></b>
                              </label>
                              <select
                                className="form-select"
                                placeholder=""
                                value={addData.purpose_enquiry}
                                onChange={(e) =>
                                  setAddData({
                                    ...addData,
                                    purpose_enquiry: e.target.value,
                                  })
                                }
                                required
                              >
                                <option value="">
                                  Select Enquiry Purpose{" "}
                                </option>
                                {responsepurpose && responsepurpose.length > 0 ? (
                                  responsepurpose.map((item, index) => (
                                    <option
                                      key={index}
                                      value={item.enquiry_purpose}
                                    >
                                      {item.enquiry_purpose}
                                    </option>
                                  ))
                                ) : (
                                  <option disabled>Loading purposes...</option>
                                )}
                              </select>

                              <label
                                className={
                                  addData.purpose_enquiry ? "filled" : ""
                                }
                              >
                                Select Enquiry Purpose
                              </label>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div
                              className={`${addData.Source_type == "Reference"
                                ? "floating-label"
                                : "d-none"
                                }`}
                            >
                              <select
                                className="form-control"
                                onChange={handlereferal}
                              >
                                <option value="">Select Reference Type</option>
                                <option value="student">Student</option>
                                <option value="staff">Staff</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-lg-6">
                            <div
                              className={`${referaltype == "student" &&
                                addData.Source_type == "Reference"
                                ? "floating-label"
                                : "d-none"
                                }`}
                            >
                              <select
                                className="form-control"
                                onChange={handleschuduleStatus}
                              >
                                <option value="">Select student</option>

                                {studentId.map((data, index) => (
                                  <option key={index} value={data._id}>
                                    {data.student_name_lead} -{data.roll_no}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div
                              className={`${referaltype == "staff" &&
                                addData.Source_type == "Reference"
                                ? "floating-label"
                                : "d-none"
                                }`}
                            >
                              <select
                                className="form-control"
                                onChange={handleschuduleStatus}
                              >
                                <option value="">Select Staff </option>
                                {stafftId.map((data, index) => (
                                  <option key={index} value={data._id}>
                                    {data.name} -{data.empid}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal.Body>

              <Modal.Footer>
                <Button
                  className="cancelbut"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  className="submitbut"
                  onClick={handlesubmit}
                  type="submit"
                  variant="primary"
                >
                  Submit
                </Button>
              </Modal.Footer>
            </form>
          </Modal>
        </div>

        <Modal show={Updateshow} onHide={() => setUpdateShow(false)}>
          <Modal.Header closeButton>
            <Modal.Title id="modeti">New Enquiry Update</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-12 ">
                <div className=" p-2 pb-0">
                  <div className="form-group">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="floating-label ">
                          <label className="form-label">
                            <b></b>
                          </label>
                          <select
                            className="form-select"
                            placeholder=""
                            value={UpdatedData.branch_id}
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                branch_id: e.target.value,
                              })
                            }
                            required
                          >
                            <option value="">Select Branch </option>
                            {branch.map((item, index) => (
                              <option key={index} value={item._id}>
                                {item.branch_name}
                              </option>
                            ))}
                          </select>
                          <label
                            className={UpdatedData.branch_id ? "filled" : ""}
                          ></label>
                        </div>

                        <div className="floating-label ">
                          <input
                            className="form-control"
                            type="text"
                            placeholder=""
                            value={UpdatedData.student_name}
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                student_name: e.target.value,
                              })
                            }
                            required
                          />
                          <label
                            className={UpdatedData.student_name ? "filled" : ""}
                          >
                            Name
                          </label>
                        </div>

                        <div className="floating-label">
                          <input
                            className="form-control"
                            type="text"
                            inputMode="numeric"
                            maxLength={10}
                            placeholder=""
                            value={UpdatedData.mobile_no}
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                mobile_no: e.target.value,
                              })
                            }
                            required
                          />
                          <label className={UpdatedData.mobile_no ? "filled" : ""}>
                            Mobile No
                          </label>
                        </div>

                        <div className="floating-label">
                          <input
                            className="form-control"
                            type="email"
                            placeholder=""
                            value={UpdatedData.email}
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                email: e.target.value,
                              })
                            }
                            required
                          />
                          <label className={UpdatedData.email ? "filled" : ""}>
                            Email
                          </label>
                        </div>

                        <div className="floating-label">
                          <select
                            className="form-control"
                            value={UpdatedData.Source_type || "Website"}
                            onChange={handleSelectChangesource}
                            required
                          >
                            <option value="">Select Source Type</option>
                            {responsesource && responsesource.length > 0 ? (
                              responsesource.map((item, index) => (
                                <option key={index} value={item.source_type || item}>
                                  {item.source_type || item}
                                </option>
                              ))
                            ) : (
                              <option value="Website">Website</option>
                            )}
                          </select>

                          <label
                            className={UpdatedData.Source_type ? "filled" : ""}
                          >
                            Source Type
                          </label>
                        </div>

                        <div className="col-lg-12 mt-3">
                          <div
                            className={`${UpdatedData.Source_type == "Reference"
                              ? "floating-label"
                              : "d-none"
                              }`}
                          >
                            <select
                              className="form-control"
                              value={UpdatedData.referal_candidate}
                              onChange={(e) =>
                                setUpdatedData({
                                  ...UpdatedData,
                                  referal_candidate: e.target.value,
                                })
                              }
                            >
                              <option value="">Select Reference Type</option>
                              <option value="student">Student</option>
                              <option value="staff">Staff</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="col-lg-12">
                          <div className="floating-label">
                            <label className="form-label"></label>
                            <select
                              className="form-select"
                              value={UpdatedData.category || ""}
                              onChange={handleEditCategoryChange}
                              required
                            >
                              <option value="">Select Category</option>
                              {category && category.length > 0 ? (
                                category.map((item, index) => (
                                  <option key={index} value={item.category_name}>
                                    {item.category_name}
                                  </option>
                                ))
                              ) : (
                                <option disabled>Loading categories...</option>
                              )}
                            </select>
                            <label className={UpdatedData.category ? "filled" : ""}>
                              Select Course Category
                            </label>
                          </div>
                        </div>

                        {/* FIXED: Course Select in Edit Modal */}
                        <div className="floating-label">
                          <label className="form-label"></label>
                          <select
                            className="form-select"
                            value={UpdatedData.course_id || ""}
                            onChange={handleCOureseUpdate}
                            required
                          >
                            <option value="">Select Course</option>
                            {responseDatas && responseDatas.length > 0 ? (
                              responseDatas.map((item, index) => (
                                <option key={index} value={item.course_id}>
                                  {item.course_id} - {item.course_name}
                                </option>
                              ))
                            ) : (
                              <option disabled>No courses available for {UpdatedData.category || "this category"}</option>
                            )}
                          </select>
                          <label className={UpdatedData.course_id ? "filled" : ""}>
                            Select Course
                          </label>
                          {responseDatas.length === 0 && UpdatedData.category && (
                            <small className="text-danger">
                              No courses found for "{UpdatedData.category}". Please check the course database.
                            </small>
                          )}
                        </div>

                        <div className="floating-label">
                          <input
                            className="form-control"
                            type="date"
                            placeholder=""
                            value={
                              UpdatedData.Enquiry_date
                                ? formatDatefitching(UpdatedData.Enquiry_date)
                                : ""
                            }
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                Enquiry_date: e.target.value,
                              })
                            }
                            required
                          />
                          <label
                            className={UpdatedData.Enquiry_date ? "filled" : ""}
                          >
                            Enquiry Date
                          </label>
                        </div>

                        <div className="floating-label">
                          <input
                            className="form-control"
                            type="text"
                            placeholder=""
                            value={UpdatedData.other_location}
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                other_location: e.target.value,
                              })
                            }
                            required
                          />
                          <label
                            className={
                              UpdatedData.other_location ? "filled" : ""
                            }
                          >
                            Other location
                          </label>
                        </div>

                        <div className="floating-label">
                          <input
                            className="form-control"
                            type="text"
                            placeholder=""
                            value={UpdatedData.qualification}
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                qualification: e.target.value,
                              })
                            }
                            required
                          />
                          <label
                            className={
                              UpdatedData.qualification ? "filled" : ""
                            }
                          >
                            Qualification
                          </label>
                        </div>

                        <div className="floating-label">
                          <select
                            className="form-control"
                            value={UpdatedData.purpose_enquiry}
                            onChange={handleSelectChange}
                            required
                          >
                            <option value="">Select Purpose</option>
                            {responsepurpose && responsepurpose.length > 0 ? (
                              responsepurpose.map((item, index) => (
                                <option
                                  key={index}
                                  value={item.enquiry_purpose}
                                >
                                  {item.enquiry_purpose}
                                </option>
                              ))
                            ) : (
                              <option disabled>Loading options...</option>
                            )}
                          </select>

                          <label
                            className={
                              UpdatedData.purpose_enquiry ? "filled" : ""
                            }
                          >
                            Purpose Enquiry
                          </label>
                        </div>

                        <div className="col-lg-12 mt-3">
                          <div
                            className={`${UpdatedData.referal_candidate === "student" &&
                              UpdatedData.Source_type === "Reference"
                              ? "floating-label"
                              : "d-none"
                              }`}
                          >
                            <select
                              className="form-control"
                              onChange={(e) =>
                                setUpdatedData({
                                  ...UpdatedData,
                                  referal_candidate_name: e.target.value,
                                })
                              }
                              value={UpdatedData.referal_candidate_name || ""}
                            >
                              <option value="">Select student</option>
                              {studentId.map((data, index) => (
                                <option key={index} value={data._id}>
                                  {data.student_name_lead} - {data.roll_no}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div
                            className={`${UpdatedData.referal_candidate === "staff" &&
                              UpdatedData.Source_type === "Reference"
                              ? "floating-label"
                              : "d-none"
                              }`}
                          >
                            <select
                              className="form-control"
                              onChange={(e) =>
                                setUpdatedData({
                                  ...UpdatedData,
                                  referal_candidate_name: e.target.value,
                                })
                              }
                              value={UpdatedData.referal_candidate_name || ""}
                            >
                              <option value="">Select Staff</option>
                              {stafftId.map((data, index) => (
                                <option key={index} value={data._id}>
                                  {data.name} - {data.empid}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setUpdateShow(false)}
            >
              Cancel
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={() => handleupdatesubmit(UpdatedData._id)}
            >
              Update
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          className="addmodals"
          show={isUpdateshowModal}
          onHide={() => setUpdateShowModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title id="modeti"> Update Schedule </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-12 ">
                <div className=" p-2 pb-0">
                  <div className="form-group">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="floating-label mt-1">
                          <label className="form-label">
                            <b></b>
                          </label>
                          <select
                            className="form-select"
                            placeholder=""
                            value={UpdatedData.branch_id}
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                branch_name: e.target.value,
                              })
                            }
                            required
                            disabled
                          >
                            <option>Select Branch </option>
                            {branch.map((item, index) => (
                              <option key={index} value={item._id}>
                                {item.branch_name}
                              </option>
                            ))}
                          </select>
                        </div>{" "}
                      </div>

                      <div className="col-lg-6">
                        <div className="floating-label">
                          <input
                            className="form-control"
                            type="text"
                            placeholder=""
                            disabled
                            value={UpdatedData.student_name}
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                student_name: e.target.value,
                              })
                            }
                            required
                          />
                          <label
                            className={updateData.student_name ? "filled" : ""}
                          >
                            Name
                          </label>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="floating-label">
                          <input
                            className="form-control"
                            type="tel"
                            disabled
                            placeholder=""
                            value={UpdatedData.mobile_no}
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                mobile_no: e.target.value,
                              })
                            }
                            required
                          />
                          <label className={addData.mobile_no ? "filled" : ""}>
                            Mobile No
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="floating-label">
                          <input
                            className="form-control"
                            type="email"
                            disabled
                            placeholder=""
                            value={UpdatedData.email}
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                email: e.target.value,
                              })
                            }
                            required
                          />
                          <label className={addData.email ? "filled" : ""}>
                            Email
                          </label>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="floating-label">
                          <label className="form-label">
                          </label>
                          <select
                            disabled
                            className="form-select"
                            value={UpdatedData.category}
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                category: e.target.value,
                              })
                            }
                            required
                          >
                            {category.map((item, index) => (
                              <option key={index} value={item.category_name}>
                                {item.category_name}
                              </option>
                            ))}
                          </select>
                          <label
                            className={UpdatedData.category ? "filled" : ""}
                          >
                            Select Course Category
                          </label>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="floating-label">
                          <select
                            disabled
                            className="form-select"
                            value={UpdatedData.Prefered_course}
                            onChange={handleCourseChange}
                            required
                          >
                            {responseDatas.map((item, index) => (
                              <option key={index} value={item.course_name}>
                                {item.course_id} - {item.course_name}
                              </option>
                            ))}
                          </select>
                          <label
                            className={
                              UpdatedData.Prefered_course ? "filled" : ""
                            }
                          >
                            Select Course Category
                          </label>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="floating-label">
                          <input
                            className="form-control"
                            type="date"
                            disabled
                            placeholder=""
                            value={
                              UpdatedData.Enquiry_date
                                ? formatDatefitching(UpdatedData.Enquiry_date)
                                : ""
                            }
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                Enquiry_date: e.target.value,
                              })
                            }
                            required
                          />
                          <label
                            className={UpdatedData.Enquiry_date ? "filled" : ""}
                          >
                            Enquiry Date
                          </label>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="floating-label">
                          <input
                            className="form-control"
                            type="text"
                            placeholder=""
                            value={UpdatedData.other_location}
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                other_location: e.target.value,
                              })
                            }
                            required
                          />
                          <label
                            className={
                              UpdatedData.other_location ? "filled" : ""
                            }
                          >
                            Other location
                          </label>
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <div className="floating-label">
                          <select
                            disabled
                            className="form-select"
                            placeholder=""
                            value={UpdatedData.Source_type}
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                Source_type: e.target.value,
                              })
                            }
                            required
                          >
                            <option value="">Select Source Type </option>
                            {responsesource.map((item, index) => (
                              <option key={index} value={item.source_type}>
                                {item.source_type}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="col-lg-6 mt-3">
                        <div
                          className={`${UpdatedData.Source_type == "Reference"
                            ? "floating-label"
                            : "d-none"
                            }`}
                        >
                          <select
                            disabled
                            className="form-control"
                            value={UpdatedData.referal_candidate}
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                referal_candidate: e.target.value,
                              })
                            }
                          >
                            <option value="">Select Reference Type</option>
                            <option value="student">Student</option>
                            <option value="staff">Staff</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-6 mt-3">
                        <div
                          className={`${UpdatedData.referal_candidate === "student" &&
                            UpdatedData.Source_type === "Reference"
                            ? "floating-label"
                            : "d-none"
                            }`}
                        >
                          <select
                            className="form-control"
                            disabled
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                referal_candidate_name: e.target.value,
                              })
                            }
                            value={UpdatedData.referal_candidate_name || ""}
                          >
                            <option value="">Select student</option>
                            {studentId.map((data, index) => (
                              <option key={index} value={data._id}>
                                {data.student_name_lead} - {data.roll_no}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div
                          className={`${UpdatedData.referal_candidate === "staff" &&
                            UpdatedData.Source_type === "Reference"
                            ? "floating-label"
                            : "d-none"
                            }`}
                        >
                          <select
                            disabled
                            className="form-control"
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                referal_candidate_name: e.target.value,
                              })
                            }
                            value={
                              UpdatedData.referal_candidate_name ||
                              sessionStorage.getItem("role_id")
                            }
                          >
                            <option value="">Select staff</option>
                            {stafftId.map((data, index) => (
                              <option key={index} value={data._id}>
                                {data.name} - {data.empid}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {localStorage.getItem("branch_id") === null ||
                localStorage.getItem("branch_id") === "null" ? (
                <div className="col-lg-6 mt-3">
                  <div className="floating-label">
                    <select
                      className="form-control"
                      value={UpdatedData.assign_staff}
                      onChange={handleSelectChangedd}
                      required
                    >
                      <option value="">Select Staff</option>
                      {filteredItems.map((item, index) => (
                        <option key={index} value={item._id}>
                          {item.empid} - {item.name}
                        </option>
                      ))}
                    </select>
                    <label
                      className={UpdatedData.assign_staff ? "filled" : ""}
                    ></label>
                    {console.log("the assign staff", UpdatedData.assign_staff)}
                  </div>
                </div>
              ) : (
                <div className="col-lg-6 mt-3">
                  <div className="floating-label">
                    <input
                      type="text"
                      className="form-control"
                      value={idlocal?.empid || ""}
                      disabled={true}
                      placeholder=""
                      required
                    />
                    <label className={idlocal ? "filled" : ""}>
                      Assign Staff
                    </label>
                  </div>
                </div>
              )}

              <div className="col-lg-6 mt-3">
                <div className="floating-label">
                  <select
                    className="form-control"
                    onChange={(e) =>
                      setUpdatedData({
                        ...UpdatedData,
                        contact_type: e.target.value,
                      })
                    }
                    value={UpdatedData.contact_type || ""}
                  >
                    <option value="">Contact Type</option>
                    <option value="phone">Phone Call</option>
                    <option value="email">Email</option>
                    <option value="whatsapp">Whatsapp</option>
                  </select>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="date"
                    placeholder=""
                    value={
                      UpdatedData.followups_date
                        ? formatDatefitching(UpdatedData.followups_date)
                        : new Date().toISOString().split("T")[0]
                    }
                    onChange={(e) =>
                      setUpdatedData({
                        ...UpdatedData,
                        followups_date: e.target.value,
                      })
                    }
                    required
                  />
                  <label
                    className={
                      formatDatefitching(UpdatedData.followups_date)
                        ? "filled"
                        : ""
                    }
                  >
                    Date
                  </label>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="time"
                    placeholder=""
                    value={UpdatedData.followups_time}
                    onChange={(e) =>
                      setUpdatedData({
                        ...UpdatedData,
                        followups_time: e.target.value,
                      })
                    }
                    required
                  />
                  <label className={UpdatedData.followups_time ? "filled" : ""}>
                    Time
                  </label>
                </div>
              </div>
              <div className="col-lg-6">
                <input
                  type="checkbox"
                  id="html"
                  classNameame="mx-2"
                  value="Interest"
                  onChange={(e) => interstedHandel(e)}
                />
                <label for="html">Interest</label>
                <br></br>
              </div>
              <div className="col-lg-6">
                <div className="floating-label">
                  <select
                    className="form-control"
                    value={UpdatedData.followups_status || ""}
                    onChange={(e) =>
                      setUpdatedData({
                        ...UpdatedData,
                        followups_status: e.target.value,
                      })
                    }
                    required
                  >
                    <option value="">Select Followups Status</option>
                    <option value="Rescheduled">Rescheduled</option>
                    <option value="Walkin">Walkin</option>
                    <option value="Unqualified">Unqualified</option>
                    <option value="NotReachable">Not Reachable</option>
                  </select>
                  <label
                    className={UpdatedData.followups_status ? "filled" : ""}
                  >
                    Select Followups Status
                  </label>
                </div>
              </div>

              <div
                className={`${UpdatedData.followups_status == "Rescheduled"
                  ? "row"
                  : "d-none"
                  }`}
              >
                <div className="col-lg-6">
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="date"
                      placeholder=""
                      value={
                        UpdatedData.followups_date
                          ? formatDatefitching(UpdatedData.followups_date)
                          : ""
                      }
                      onChange={(e) =>
                        setUpdatedData({
                          ...UpdatedData,
                          followups_date: e.target.value,
                        })
                      }
                      required
                    />
                    <label
                      className={UpdatedData.followups_date ? "filled" : ""}
                    >
                      Reschudule Date
                    </label>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="time"
                      placeholder=""
                      value={UpdatedData.followups_time}
                      onChange={(e) =>
                        setUpdatedData({
                          ...UpdatedData,
                          followups_time: e.target.value,
                        })
                      }
                      required
                    />
                    <label
                      className={UpdatedData.followups_time ? "filled" : ""}
                    >
                      Reschudule Time
                    </label>
                  </div>
                </div>
              </div>

              <div
                className={`${UpdatedData.followups_status == "Walkin" ? "row" : "d-none"
                  }`}
              >
                <div className="col-lg-6">
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="date"
                      placeholder=""
                      value={
                        UpdatedData.followups_date
                          ? formatDatefitching(UpdatedData.followups_date)
                          : ""
                      }
                      onChange={(e) =>
                        setUpdatedData({
                          ...UpdatedData,
                          followups_date: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={UpdatedData.status_date ? "filled" : ""}>
                      visit Date
                    </label>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="time"
                      placeholder=""
                      value={UpdatedData.followups_time}
                      onChange={(e) =>
                        setUpdatedData({
                          ...UpdatedData,
                          followups_time: e.target.value,
                        })
                      }
                      required
                    />
                    <label
                      className={UpdatedData.followups_time ? "filled" : ""}
                    >
                      visit Time
                    </label>
                  </div>
                </div>
              </div>
              <div
                className={
                  UpdatedData.followups_status === "Walkin" ||
                    UpdatedData.followups_status === "Rescheduled"
                    ? "row"
                    : "d-none"
                }
              >
                <div className="floating-label">
                  <textarea
                    className="form-control"
                    value={UpdatedData.followups_notes || ""}
                    onChange={(e) =>
                      setUpdatedData({
                        ...UpdatedData,
                        followups_notes: e.target.value,
                      })
                    }
                    required
                  ></textarea>
                  <label
                    className={UpdatedData.followups_notes ? "filled" : ""}
                  >
                    Followups Notes
                  </label>
                </div>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setUpdateShowModal(false)}
            >
              Cancel
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={() => handleupdatesubmitdetails(UpdatedData._id)}
            >
              Schedule
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          className="modal"
          show={deleteShowModals}
          onHide={handleCloseModal}
        >
          <Modal.Header>
            <p id="modeti">Are you sure you want to Delete?</p>
          </Modal.Header>
          <Modal.Body>
            <label className="form-label d-flex">
              <h5 className="mx-1"> Student :</h5> <h5>{getdeletename} </h5>
            </label>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={handleCloseModal}
            >
              Close
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handleDelete}
            >
              Delete
            </Button>
          </Modal.Footer>
        </Modal>

        <div className="mt-3 pb-5">
          <div className="row">
            <div className="col-lg-7 col-sm-12 mt-1">
              <span className="text-dark">
                Page {state.pageIndex + 1} of {pageCount}
              </span>
            </div>
            <div className="col-lg-5">
              <div className="mt-3 pb-5">
                <nav>
                  <ul className="pagination justify-content-center">
                    {createPagination()}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Student;